import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getEmailStats, getSmtpConfig, getRecentEmails, sendTestEmail, getEmailTemplates, updateEmailTemplate } from '../api/email-admin.api'

export function useEmailStats() {
  return useQuery({
    queryKey: ['admin', 'emails', 'stats'],
    queryFn: getEmailStats,
  })
}

export function useSmtpConfig() {
  return useQuery({
    queryKey: ['admin', 'emails', 'smtp-config'],
    queryFn: getSmtpConfig,
  })
}

export function useRecentEmails(limit: number = 20) {
  return useQuery({
    queryKey: ['admin', 'emails', 'recent', limit],
    queryFn: () => getRecentEmails(limit),
  })
}

export function useSendTestEmail() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: sendTestEmail,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'emails'] })
    },
  })
}

export function useEmailTemplates() {
  return useQuery({
    queryKey: ['admin', 'emails', 'templates'],
    queryFn: getEmailTemplates,
  })
}

export function useUpdateEmailTemplate() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ code, subject, body }: { code: string; subject: string; body: string }) =>
      updateEmailTemplate(code, { subject, body }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'emails', 'templates'] })
    },
  })
}
